import disposableDomains from 'disposable-email-domains';
import disposableWildcards from 'disposable-email-domains/wildcard.json';

// Personal/free-mail providers blocked on signup so paid workspaces stay
// tied to a real company domain.
const BLOCKED_EMAIL_DOMAINS = new Set([
  'gmail.com', 'googlemail.com',
  'outlook.com', 'hotmail.com', 'live.com', 'msn.com',
  'yahoo.com', 'yahoo.fr', 'yahoo.co.uk', 'ymail.com',
  'aol.com',
  'icloud.com', 'me.com', 'mac.com',
  'protonmail.com', 'proton.me',
  'zoho.com',
  'yandex.com', 'yandex.ru',
  'mail.com', 'email.com',
  'gmx.com', 'gmx.net', 'gmx.de',
  'tutanota.com', 'tuta.com',
  'fastmail.com',
  'hey.com',
  'mailfence.com',
  'disroot.org',
  'riseup.net',
  'posteo.de',
  'inbox.com',
  'rediffmail.com',
  'web.de',
  't-online.de',
  'orange.fr', 'wanadoo.fr', 'free.fr', 'laposte.net', 'sfr.fr',
]);

const DISPOSABLE_DOMAINS = new Set(disposableDomains);
const DISPOSABLE_WILDCARDS = disposableWildcards as string[];

export function getEmailDomain(email: string): string | null {
  const at = email.lastIndexOf('@');
  if (at < 0) return null;
  const domain = email.slice(at + 1).trim().toLowerCase();
  return domain || null;
}

export function isPersonalEmailDomain(email: string): boolean {
  const domain = getEmailDomain(email);
  return !!domain && BLOCKED_EMAIL_DOMAINS.has(domain);
}

export function isDisposableEmailDomain(email: string): boolean {
  const domain = getEmailDomain(email);
  if (!domain) return false;
  if (DISPOSABLE_DOMAINS.has(domain)) return true;
  return DISPOSABLE_WILDCARDS.some(
    (wildcard) => domain === wildcard || domain.endsWith(`.${wildcard}`),
  );
}

/** True when the address is a personal free-mail or disposable/temp domain. */
export function isBlockedSignupEmail(email: string): boolean {
  return isPersonalEmailDomain(email) || isDisposableEmailDomain(email);
}

export function validateWorkEmail(email: string): string | null {
  const trimmed = email.trim();
  if (!/^\S+@\S+\.\S+$/.test(trimmed)) {
    return 'Please enter a valid email address.';
  }
  if (isBlockedSignupEmail(trimmed)) {
    return 'Please use your work email, not a personal email.';
  }
  return null;
}
